const API_URL = process.env.REACT_APP_API_URL;
const CDN_URL = process.env.REACT_APP_CDN_URL;
const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || undefined;

const VERSION = '1.0';

const MAX_RESULT = 10;

const COOKIE_CONFIG = {
    maxAge: (60 * 60 * 24 * 120),
    path: "/",
    domain: COOKIE_DOMAIN,
    secure: false,
    sameSite: "Lax"
}

const COLOR_CATEGORY_ID = 1;

const Config = {
    API_URL,
    CDN_URL,
    MAX_RESULT,
    VERSION,
    COOKIE_CONFIG,
    COLOR_CATEGORY_ID,
};

export default Config;
